// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---packages-gatsby-theme-legal-src-components-document-document-js": () => import("./../../../../../packages/gatsby-theme-legal/src/components/Document/Document.js" /* webpackChunkName: "component---packages-gatsby-theme-legal-src-components-document-document-js" */),
  "component---packages-gatsby-theme-legal-src-components-index-page-index-page-js": () => import("./../../../../../packages/gatsby-theme-legal/src/components/IndexPage/IndexPage.js" /* webpackChunkName: "component---packages-gatsby-theme-legal-src-components-index-page-index-page-js" */)
}

